export type { ClientLoggerContext } from "@bindery/logging/client";
import { logging } from "./backend";

export const { createClientLogger } = logging;
